import { render, staticRenderFns } from "./DictionariesSync.vue?vue&type=template&id=013bb216&scoped=true"
import script from "./DictionariesSync.vue?vue&type=script&lang=js"
export * from "./DictionariesSync.vue?vue&type=script&lang=js"
import style0 from "./DictionariesSync.vue?vue&type=style&index=0&id=013bb216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013bb216",
  null
  
)

export default component.exports